import {Component, OnDestroy, OnInit} from "@angular/core";
import {noop, Subject, takeUntil} from "rxjs";
import {SFTPAPIService} from "@app/services/sftp-api/sftp-api.service";
import {AuthorizationService} from "@app/services/authorization.service";
import {Type as InputType} from "@pb-labs/text-input";
import {AppConfig} from "@app/services/app.config";
import {SFTPMainPages} from "@app/modules/models";
import {Router} from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit, OnDestroy {
  resetApiUrl: string;
  username: string = null;
  password: string = null;
  readonly inputType = InputType;

  private _destroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private appConfig: AppConfig,
    private sftpAPIService: SFTPAPIService,
    private authorizationService: AuthorizationService
  ) {}

  get loginInProgress(): boolean {
    return this.authorizationService.loginInProgress;
  }

  get loginError(): string {
    return this.authorizationService.loginError;
  }

  get userAuthorized(): boolean {
    return this.authorizationService.userAuthorized;
  }

  ngOnInit() {
    this.authorizationService.initialize();

    this.resetApiUrl = this.appConfig.settings.resetApi.url;

    this.authorizationService
      .username$()
      .pipe(takeUntil(this._destroy$))
      .subscribe((username: string) => {
        this.username = username;
      });

    this.authorizationService
      .password$()
      .pipe(takeUntil(this._destroy$))
      .subscribe((password: string) => {
        this.password = password;
      });
  }

  ngOnDestroy(): void {
    this.authorizationService.destroy();

    this._destroy$.next();
    this._destroy$.complete();
  }

  onResetClick(): void {
    window.location.href = `${this.resetApiUrl}&redirect_uri=${encodeURIComponent(window.location.origin)}`;
  }

  onSubmit(): void {
    this.authorizationService
      .userAuthorization({
        username: this.username,
        password: this.password,
      })
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: () => {
          this.router.navigate([`/${SFTPMainPages.browse}`]).catch(console.error);
        },
        error: noop,
      });
  }
}
